module.exports = __webpack_public_path__ + "static/cp-feature-2-32097330efdd290df3276acd7b28a1e4.png";